import { Radio } from 'antd';
import type { RadioChangeEvent } from 'antd';
import usePageMetadata from '@/hooks/usePageMetadata';
import { MIXPANEL_EVENT } from '@/utils/mixpanelUtils/events';
import { trackContentPerformanceEventIfApplicable } from '@/routes/ContentPerformancePage/trackingUtils';
import type { LaunchWindowDays } from '@/types/content';

interface LaunchWindowControlsProps {
  windowDays: LaunchWindowDays;
  onWindowChange: (windowDays: LaunchWindowDays) => void;
}

const WINDOW_OPTIONS: Array<{ value: LaunchWindowDays; label: string }> = [
  { value: 7, label: 'First 7 days' },
  { value: 30, label: 'First 30 days' },
];

/**
 * Segmented radio control for selecting the post-launch comparison window (7 or 30 days).
 */
const LaunchWindowControls = ({ windowDays, onWindowChange }: LaunchWindowControlsProps) => {
  const { page } = usePageMetadata();

  return (
    <div className="flex w-full md:justify-end my-6">
      <Radio.Group
        options={WINDOW_OPTIONS}
        optionType="button"
        buttonStyle="solid"
        value={windowDays}
        aria-label="Launch window"
        className="flex w-full [&>label]:flex-1 [&>label]:text-center"
        onChange={(event: RadioChangeEvent) => {
          const nextWindowDays = event.target.value as LaunchWindowDays;
          if (nextWindowDays === windowDays) return;
          trackContentPerformanceEventIfApplicable(
            page,
            MIXPANEL_EVENT.contentPerformance.chart.launchWindowChanged,
            { windowDays: nextWindowDays }
          );
          onWindowChange(nextWindowDays);
        }}
      />
    </div>
  );
};

export default LaunchWindowControls;
